module.exports = __webpack_public_path__ + "media/48.5001e7ef.mp3";